import { QueryClient } from '@tanstack/react-query';

export const MY_LIST_CONFIG_CACHE_KEY = 'my-list-config';
export const MY_LIST_IDS_CACHE_KEY = 'get-my-list';

type CarouselQueryKeyParams = {
    carouselParams?: {
        isMyList?: boolean | null;
        model?: string | null;
    };
};

function getCarouselParamsFromQueryKey(
    queryKey: unknown,
): CarouselQueryKeyParams['carouselParams'] {
    if (!Array.isArray(queryKey)) {
        return undefined;
    }
    const dataParams = queryKey[1] as CarouselQueryKeyParams | undefined;
    return dataParams?.carouselParams;
}

export function isMyListCarouselQuery(query: { queryKey: unknown }): boolean {
    return getCarouselParamsFromQueryKey(query.queryKey)?.isMyList === true;
}

/**
 * Refresh my-list lookups and active carousels after sign-in.
 * Uses invalidate + refetch (same strategy as toggle add/remove) — not removeQueries,
 * which drops cache entries and breaks subsequent carousel optimistic updates.
 */
export async function invalidateMyListAfterAuthChange(queryClient: QueryClient): Promise<void> {
    await Promise.all([
        queryClient.invalidateQueries({ predicate: isMyListCarouselQuery }),
        queryClient.invalidateQueries({ queryKey: [MY_LIST_CONFIG_CACHE_KEY] }),
        queryClient.invalidateQueries({ queryKey: [MY_LIST_IDS_CACHE_KEY] }),
    ]);
    await Promise.all([
        queryClient.refetchQueries({ queryKey: [MY_LIST_CONFIG_CACHE_KEY], type: 'active' }),
        queryClient.refetchQueries({ queryKey: [MY_LIST_IDS_CACHE_KEY], type: 'active' }),
        queryClient.refetchQueries({ predicate: isMyListCarouselQuery, type: 'all' }),
    ]);
}
